<template>
  <v-row  class="center-cards">
    <v-col v-if="isNotify" cols="12"  md="12" lg="3">
      <v-card>
        <v-card-text>
          <div v-html="htmlContent"></div>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col  cols="12"  md="12" lg="3">
      <v-card>
        <v-card-text>
          <div class="text-center">
            <v-icon x-large color="amber">mdi-store</v-icon>
          </div>
          <!-- <div class="my-4">
            <p>
              <span class="text-h5 font-weight-medium">Soy un minorista</span>
              <br />
              <br />
              <span class="text-body-2">Lista de productos directo a su negocio</span>
              <br />
              <span class="text-caption font-weight-medium">* Cobertura de despacho limitada</span>
            </p>
          </div> -->
          <div v-if="ubigeos.length === 0">
            Cargando ...
          </div>
          <div v-else>
            <div>
              Departamento
            </div>
            <div>
              <select
                v-model="selectedDepartamento"
                style="width:100%"
                class="vselect"
              >
                <option
                  v-for="u in ubigeos"
                  :key="`dep-${u.name}`"
                  :value="u.name"
                >
                  {{u.name}}
                </option>
              </select>
            </div>
            <div class="mt-6">
              Provincia
            </div>
            <div>
              <select
                v-model="selectedProvincia"
                style="width:100%"
                class="vselect"
              >
                <option
                  v-for="u in availableProvincias"
                  :key="`prov-${u.name}`"
                  :value="u.name"
                >
                  {{u.name}}
                </option>
              </select>
            </div>
            <div class="mt-6">
              Distrito
            </div>
            <div class="mb-4">
              <select
                v-model="selectedDistrito"
                style="width:100%"
                class="vselect"
              >
                <option
                  v-for="u in availableDistritos"
                  :key="`dist-${u.name}`"
                  :value="u.ubigeoId"
                >
                  {{u.name}}
                </option>
              </select>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12" md="12" lg="4">
      <v-row>
        <v-col class="pt-0" cols="12" sm="12" md="12" lg="6" xl="6" v-for="(d, $i) in availableDistribuidores" :key="$i">
          <Distribuidor class="center-cards" :data="d" />
        </v-col>
        <v-col
          cols="12" sm="12" md="12"
           v-if="selectedDistrito  !== null && selectedDistrito !== undefined && availableDistribuidores.length === 0"
        >
          <Subscribe :selectedUbigeo="selectedDistrito" />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import Distribuidor from '../components/Distribuidor'
import Subscribe from '../components/Subscribe'
import { queryUrl } from '../utils/http'

async function getUbigeos () {
  const body = await queryUrl('https://services.plazatodo.com/getUbigeos')
  return body
}

async function getData () {
  const body = await queryUrl('https://services.plazatodo.com/getData')
  return body
}

function formatUrl (url) {
  if (url[url.length - 1] === '/') {
    return `${url}`
  } else {
    return `${url}/`
  }
}

export default {
  name: 'Home',
  created: function () {
    this.handlerUrl()
  },
  data () {
    return {
      ubigeos: [],
      availableProvincias: [],
      availableDistritos: [],
      selectedDepartamento: null,
      selectedProvincia: null,
      selectedDistrito: null,
      distributors: [],
      isNotify: false,
      htmlContent: null,
      host: 'https://demo.geosales.cloud',
      type: {
        NOTICIA: {
          sdk: 'consultarPublicaciones',
          html: function (data, host) {
            const html = `
              <img width="100%" src="${host}/${data.ruta}/${data.adjunto_portada_int}"/>
              ${data.detalle}
            `
            return html
          }
        },
        PROMO: {
          sdk: 'consultarPromociones',
          html: function (data, host) {
            console.log(data)

            const html = `
              <h3 style="color: black">${data.nombre}</h3>
              <img width="100%" src="${host}/${data.ruta}${data.adjunto}"/>
              <div style="display: flex; flex-direction: row; justify-content: center; color: black;">
                <p style="margin: 5px; text-align: center">Desde: ${data.fecha_ini}</p>
                <p style="margin: 5px; text-align: center">Hasta: ${data.fecha_fin}</p>
              </div>
              ${data.descripcion}
            `
            return html
          }
        }
      },
      config: {
        token: '0987654321jlglhjgljhkhgkjghkgd7it7f976f7gf854s754',
        origen: 'GENTK01'
      }
    }
  },
  computed: {
    availableDistribuidores () {
      const result = this.distributors.filter(u => u.cubigeo_id === this.selectedDistrito)
      if (result.length === 1) {
        localStorage.lastDistribuidor = JSON.stringify(result[0])
        window.location.assign(
          formatUrl(result[0].Url)
        )
      }
      return result
    }
  },
  mounted () {
    getUbigeos().then(body => {
      this.ubigeos = [...this.buildUbigeos(body)]
      this.selectedDepartamento = 'LIMA'
      this.selectedProvincia = 'LIMA'
    })
    getData().then(body => {
      this.distributors = [...body]
    })
  },
  watch: {
    selectedDepartamento (newVal, oldVal) {
      this.availableProvincias = this.ubigeos.find(u => u.name === newVal).provincias
      const prov = this.availableProvincias.find(p => p.name === this.selectedProvincia)
      if (prov) {
        this.availableDistritos = prov.distritos
      }
      this.selectedDistrito = null
    },
    selectedProvincia (newVal, oldVal) {
      this.availableDistritos = this.availableProvincias.find(p => p.name === newVal).distritos
      this.selectedDistrito = null
    }
  },
  methods: {
    buildUbigeos (ubigeos) {
      const departamentos = []
      ubigeos.forEach(ubigeo => {
        const dep = departamentos.find(d => d.name === ubigeo.cdepartamento)
        if (dep) {
          const prov = dep.provincias.find(p => p.name === ubigeo.cprovincia)
          if (prov) {
            const dist = prov.distritos.find(d => d.name === ubigeo.cdistrito)
            if (dist === undefined) {
              prov.distritos.push({
                name: ubigeo.cdistrito,
                ubigeoId: ubigeo.cubigeo_id
              })
            }
          } else {
            dep.provincias.push({
              name: ubigeo.cprovincia,
              distritos: [{
                name: ubigeo.cdistrito,
                ubigeoId: ubigeo.cubigeo_id
              }]
            })
          }
        } else {
          departamentos.push({
            name: ubigeo.cdepartamento,
            provincias: [{
              name: ubigeo.cprovincia,
              distritos: [{
                name: ubigeo.cdistrito,
                ubigeoId: ubigeo.cubigeo_id
              }]
            }]
          })
        }
      })
      return departamentos
    },
    handlerUrl: function () {
      const uri = new URLSearchParams(window.location.search)
      const token = uri.has('tk') ? uri.get('tk') : ''
      const data = uri.has('data') ? uri.get('data') : ''

      if (token === 'notify' && token !== data) {
        const [type, id] = data.split('-')

        this.httpMethod(type, id)
      }
    },
    httpMethod: async function (type, data) {
      const body = new URLSearchParams()
      body.append('Tipo_Respuesta', 'JSON')
      body.append('token', this.config.token)
      body.append('origen', this.config.origen)
      body.append('ids', data)

      const request = await fetch(this.host + '/monitoreoservicios/monitor/sdk/index.php/' + this.type[type].sdk, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: body
      })

      const response = await request.json()

      console.log(this.handlerResponse(response, type))
    },
    showNotification: function () {
      this.isNotify = true
    },
    handlerResponse: function (data, type) {
      const log = Array.isArray(data.log) ? data.log : []

      if (log.length === 0) return false

      const response = log[0]

      if (response.result !== 1 || response.datos?.res !== 1) return false

      const rawNotification = Array.isArray(response.datos?.datos) ? response.datos.datos : []

      if (rawNotification.length === 0) return false

      const notification = rawNotification[0]

      this.htmlContent = this.type[type].html(notification, this.host)

      this.showNotification()
    }
  },
  components: {
    Distribuidor,
    Subscribe
  }
}
</script>

<style scoped>
.vselect {
  height: 45px;
  width: auto;
  max-width: 100%;
  padding: 0 35px 0 20px;
  border: 1px solid #e7e7e7;
  /* border-radius: 3px; */
  border-radius: 10px;
  background: #fff url("https://plazatodo.com/Themes/Emporium/Content/img/select-arrow-dark.svg") no-repeat right 15px center;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
}
</style>
